import { trpc } from '@tencent/tpro_rmonitor_web_server_basic';
import { stores } from '@/presentation/store';
import { FieldKey, Zone } from '@/proto/field';
import { WithTypeCast } from '@raft/utils';

export enum TagBaseType {
  MemDetail = 'mem_detail',
  Exception = 'exception',
  Lag = 'lag_problem_list',   // 卡顿
  JavaLeak = 'memory_leak',
  VcLeak = 'memory_leak',
  BigPic = 'memory_bitmap',   // 大图分析
  BadMalloc = 'memory_bad_malloc', // 大块分配内存
  Launch = '', // 启动（占位）
  Fd = 'memory_fd_leak',
  Anr = 'looper_deadlock',
  Native = 'memory_native',
  Compliance = 'compliance', // 合规
  Foom = 'memory_foom',
  FoomMalloc = 'foom_malloc',
  Net = 'traffic',
  Resource='resource',

}

export enum TagSubType {
  MemDetail = 'mem_detail',
  Exception = 'exception',
  Lag = 'looper_stack',               // 卡顿
  JavaLeak = 'memory_leak_problem',
  VcLeak = 'memory_leak_problem',
  BigPic = 'memory_bitmap_problem',   // 大图分析
  BadMalloc = 'memory_bad_malloc_problem', // 大块内存分配
  Launch = '', // 启动（占位）
  Fd = 'memory_fd_leak_problem',
  Anr = 'deadlock',
  Native = 'native_memory',
  Compliance = 'compliance_issue', // 合规列表
  ComplianceSelfLaunch = 'compliance_self_launch',
  Foom = 'memory_foom_problem',
  FoomMalloc = 'foom_malloc_problem',
  Net = 'traffic',
  BatteryElement='battery_element',
}

export type TagInfo = {
  tagId: string;
  tagName: string;
  tagColor: string;
};

export type ITag = WithTypeCast<trpc.rmonitor.web_server.ITag>;

export const updateField = async (baseType: TagBaseType) => {
  const map: Partial<Record<TagBaseType, Zone>> = {
    [TagBaseType.Lag]: Zone.Lag,
    [TagBaseType.VcLeak]: Zone.VcLeak,
    [TagBaseType.JavaLeak]: Zone.JavaLeak,
    [TagBaseType.BigPic]: Zone.BigPic,
    [TagBaseType.BadMalloc]: Zone.BadMalloc,
    [TagBaseType.Fd]: Zone.Fd,
    [TagBaseType.Anr]: Zone.Anr,
    [TagBaseType.Foom]: Zone.Foom,
    [TagBaseType.FoomMalloc]: Zone.FoomMalloc,
    [TagBaseType.Native]: Zone.Native,
  };
  const zone = map[baseType];
  if (zone) {
    await stores.FieldStore.updateField(FieldKey.Tags, zone);
  }
};

export const formatTags = (tags: ITag[]) => tags.map(info => ({
  tagId: info.id || '',
  tagName: info.name || '',
  tagColor: info.color || '',
}));
